/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JsonFileInfo
 */
export interface JsonFileInfo {
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonFileInfo
     */
    allowedActions?: Array<JsonFileInfoAllowedActionsEnum>;
    /**
     * 
     * @type {number}
     * @memberof JsonFileInfo
     */
    companyId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonFileInfo
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonFileInfo
     */
    createdBy?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonFileInfo
     */
    fileId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonFileInfo
     */
    fileName?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonFileInfo
     */
    fileSize?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonFileInfo
     */
    fileType?: JsonFileInfoFileTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof JsonFileInfo
     */
    guid?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonFileInfo
     */
    hash?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonFileInfo
     */
    mimeType?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonFileInfo
     */
    serieId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonFileInfo
     */
    status?: JsonFileInfoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof JsonFileInfo
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonFileInfo
     */
    updatedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonFileInfo
     */
    updatedBy?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonFileInfo
     */
    userId?: number;
}

/**
* @export
* @enum {string}
*/
export enum JsonFileInfoAllowedActionsEnum {
    View = 'VIEW',
    Edit = 'EDIT'
}/**
* @export
* @enum {string}
*/
export enum JsonFileInfoFileTypeEnum {
    Logo = 'LOGO'
}/**
* @export
* @enum {string}
*/
export enum JsonFileInfoStatusEnum {
    Deleted = 'DELETED',
    Active = 'ACTIVE'
}

export function JsonFileInfoFromJSON(json: any): JsonFileInfo {
    return JsonFileInfoFromJSONTyped(json, false);
}

export function JsonFileInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonFileInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allowedActions': !exists(json, 'allowedActions') ? undefined : json['allowedActions'],
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'fileId': !exists(json, 'fileId') ? undefined : json['fileId'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
        'fileSize': !exists(json, 'fileSize') ? undefined : json['fileSize'],
        'fileType': !exists(json, 'fileType') ? undefined : json['fileType'],
        'guid': !exists(json, 'guid') ? undefined : json['guid'],
        'hash': !exists(json, 'hash') ? undefined : json['hash'],
        'mimeType': !exists(json, 'mimeType') ? undefined : json['mimeType'],
        'serieId': !exists(json, 'serieId') ? undefined : json['serieId'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
    };
}

export function JsonFileInfoToJSON(value?: JsonFileInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allowedActions': value.allowedActions,
        'companyId': value.companyId,
        'createdAt': value.createdAt,
        'createdBy': value.createdBy,
        'fileId': value.fileId,
        'fileName': value.fileName,
        'fileSize': value.fileSize,
        'fileType': value.fileType,
        'guid': value.guid,
        'hash': value.hash,
        'mimeType': value.mimeType,
        'serieId': value.serieId,
        'status': value.status,
        'title': value.title,
        'updatedAt': value.updatedAt,
        'updatedBy': value.updatedBy,
        'userId': value.userId,
    };
}

